import TableBody from '@material-ui/core/TableBody';

export default TableBody;
